import React from "react";
import { Box, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

interface BlockShellProps {
  label: string;
  children: React.ReactNode;
  canMoveUp: boolean;
  canMoveDown: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
}

/** Card chrome around every builder block: label + hover actions. */
export default function BlockShell({
  label,
  children,
  canMoveUp,
  canMoveDown,
  onMoveUp,
  onMoveDown,
  onDuplicate,
  onDelete,
}: BlockShellProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        position: "relative",
        "& .block-actions": { opacity: 0, transition: "opacity 120ms" },
        "&:hover .block-actions": { opacity: 1 },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <DragIndicatorIcon sx={{ fontSize: 18, color: "text.disabled", mr: 0.5 }} />
        <Typography
          variant="caption"
          sx={{ color: "text.secondary", textTransform: "uppercase", letterSpacing: 0.6 }}
        >
          {label}
        </Typography>
        <Box className="block-actions" sx={{ ml: "auto", display: "flex" }}>
          <Tooltip title="Move up" arrow>
            <span>
              <IconButton size="small" onClick={onMoveUp} disabled={!canMoveUp}>
                <KeyboardArrowUpIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Move down" arrow>
            <span>
              <IconButton size="small" onClick={onMoveDown} disabled={!canMoveDown}>
                <KeyboardArrowDownIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Duplicate" arrow>
            <IconButton size="small" onClick={onDuplicate}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" arrow>
            <IconButton size="small" onClick={onDelete}>
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      {children}
    </Paper>
  );
}
